(() => {
  const storageKey = 'pas.wishlist';

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : [];
    } catch {
      return [];
    }
  };

  const write = (handles) => {
    try { localStorage.setItem(storageKey, JSON.stringify(handles)); } catch { /* Storage can be unavailable. */ }
  };

  const refresh = () => {
    const wished = new Set(read());
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = wished.has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      const prefix = active ? 'Remove' : 'Save';
      const title = button.closest('pas-product-card')?.querySelector('.pas-card__title')?.textContent?.trim();
      button.setAttribute('aria-label', title ? `${prefix} ${title} ${active ? 'from' : 'to'} wishlist` : `${prefix} ${active ? 'from' : 'to'} wishlist`);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-wishlist-toggle]') : null;
    if (!button) return;
    const handle = button.dataset.productHandle;
    if (!handle) return;
    const handles = read();
    write(handles.includes(handle) ? handles.filter((item) => item !== handle) : [...handles, handle]);
    refresh();
  });

  document.addEventListener('pas:cards-rendered', refresh);
  refresh();
})();
